export class StepperStep {
  private name: string;
  private stepperComponent: JSX.Element[];
  private stepperOutlet: JSX.Element;
  constructor(
    name: string,
    stepperComponent: JSX.Element[],
    stepperOutlet: JSX.Element
  ) {
    this.name = name;
    this.stepperComponent = stepperComponent;
    this.stepperOutlet = stepperOutlet;
  }

  get stepName() {
    return this.name;
  }

  get stepStepperComponent() {
    return this.stepperComponent;
  }

  get stepStepperOutlet() {
    return this.stepperOutlet;
  }
}
